import * as React from 'react';
import Box from '@mui/material/Box';
import { GridRenderCellParams, GridRowId } from '@mui/x-data-grid';
import Image from "next/image";

interface ImageValueProps {
  url: string;
  alt?: string;
  width?: number;
  height?: number;
}

export const ImageValue = ({ url, alt, width, height }: ImageValueProps) => {
  return (
    <Box
      sx={{
        height: 150,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Image
        src={url}
        alt={alt || ''}
        width={width || 80}
        height={height || 80}
        style={{
          maxWidth: "100%",
          height: "auto"
        }} />
    </Box>
  );
};

const MemoizedImageValue = React.memo(ImageValue);

export function renderImage(
  params: GridRenderCellParams<any, { id: GridRowId }, any>
) {
  if (params.rowNode.isAutoGenerated || params.value == null) {
    return '';
  }
  return (
    <MemoizedImageValue
      url={params.value.url}
      alt={params.value.alt}
      width={params.value.width}
      height={params.value.height}
    />
  );
}
